import styled from 'styled-components'

const Tag = styled.span`
  background-color: #F1F3F5;
  padding: 5px 7px;
  border-radius: 20px;
  margin-right: 5px;
  margin-bottom: 5px;
  display: inline-flex;
`
export default Tag
